export interface IArtistVisibilityChange {
    visible: number;
    artist_id: string;
}
